import { Award, Shield, Clock, Users, MapPin, Star } from "lucide-react";

export default function AboutPage() {
  return (
    <div className="min-h-screen">
      {/* Hero */}
      <section className="bg-gradient-to-br from-primary/5 to-primary/10 py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid lg:grid-cols-2 gap-10 items-center">
          <div>
            <h1 className="text-4xl font-bold text-foreground mb-4">
              India's Most Trusted<br /><span className="text-primary">Diagnostic Centre</span>
            </h1>
            <p className="text-muted-foreground text-lg mb-6 leading-relaxed">
              Since 2010, DiagnoPlus has been committed to delivering accurate, affordable, and accessible diagnostic services to millions across India.
            </p>
            <div className="grid grid-cols-3 gap-4">
              {[
                { value: "15+", label: "Years" },
                { value: "2M+", label: "Patients" },
                { value: "50+", label: "Cities" },
              ].map(s => (
                <div key={s.label} className="text-center bg-background border border-border rounded-xl p-4">
                  <p className="text-2xl font-bold text-primary">{s.value}</p>
                  <p className="text-xs text-muted-foreground">{s.label}</p>
                </div>
              ))}
            </div>
          </div>
          <img
            src="https://images.unsplash.com/photo-1551601651-2a8555f1a136?w=600&h=400&fit=crop"
            alt="Lab"
            className="rounded-2xl shadow-xl w-full h-[350px] object-cover"
          />
        </div>
      </section>

      {/* Values */}
      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14">
        <h2 className="text-2xl font-bold text-foreground text-center mb-10">Our Values</h2>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
          {[
            { icon: Award, title: "Accreditation", desc: "NABL & CAP certified labs meeting international standards" },
            { icon: Shield, title: "Accuracy", desc: "99.9% test accuracy with stringent quality protocols" },
            { icon: Clock, title: "Speed", desc: "Same-day or next-day reports for all major tests" },
            { icon: Users, title: "Accessibility", desc: "Affordable pricing, EMI options, and health insurance tie-ups" },
          ].map(v => (
            <div key={v.title} className="text-center p-6 bg-card border border-border rounded-xl">
              <div className="w-12 h-12 rounded-full bg-primary/10 flex items-center justify-center mx-auto mb-3">
                <v.icon className="h-6 w-6 text-primary" />
              </div>
              <h3 className="font-semibold text-foreground mb-2">{v.title}</h3>
              <p className="text-xs text-muted-foreground">{v.desc}</p>
            </div>
          ))}
        </div>
      </section>

      {/* Accreditations */}
      <section className="bg-muted/30 py-10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-xl font-bold text-foreground mb-6">Certifications & Accreditations</h2>
          <div className="flex flex-wrap justify-center gap-4">
            {["NABL", "ISO 15189:2022", "CAP", "ICMR", "WHO GMP"].map(cert => (
              <div key={cert} className="px-5 py-3 bg-background border border-border rounded-xl font-semibold text-sm text-foreground">
                ✅ {cert}
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
